/** Dashboard lug'ati (ru) */
export default {
  loadError: "Не удалось загрузить дашборд.",
  greeting: { morning: "Доброе утро, {{name}}", afternoon: "Добрый день, {{name}}", evening: "Добрый вечер, {{name}}" },
  dateLine: "{{date}} · Даллас {{dallas}} {{abbr}} · Ташкент {{tashkent}}",
  period: "Период",
  daysValue_one: "{{count}} день",
  daysValue_few: "{{count}} дня",
  daysValue_many: "{{count}} дней",
  daysValue_other: "{{count}} дня",
  delta: { same: "как в {{month}}", vs: "{{arrow}} {{count}} к {{month}}" },
  kpi: {
    newDrivers: "Новые водители",
    submitted: "Отправлено перевозчикам",
    waitingReply: "{{count}} ждут ответа",
    hired: "Нанято",
    pendingApproval: "+{{count}} ждут подтверждения",
    approvedByManager: "подтверждено менеджером",
    myBonus: "Мой бонус · {{month}}",
    bonusEstimated: "предварительно, итог после подтверждения",
    hires: "Наймы",
    hiresPrevIn: "{{count}} в {{month}}",
    pctVsPrev: "{{arrow}} {{pct}}% к {{month}}",
    pendingShort: " · {{count}} в ожидании",
    inPipeline: "В воронке",
    activeDrivers: "активных водителей",
    avgTimeToHire: "Среднее время найма",
    vsPrevNone: "к {{month}}: —",
    daysVsPrev: "{{arrow}} {{count}} дн. к {{month}}",
    daysIn: "{{days}} в {{month}}",
    noHiresYet: "наймов пока нет",
    retention30: "Удержание 30 дней",
    retention30Sub: "наймы, прошедшие 30 дней",
    costPerHire: "Стоимость найма",
    costPerHireSub: "расходы + зарплаты + бонусы",
  },
  myFunnel: "Моя воронка · {{month}}",
  funnelHint: "% = конверсия с предыдущего шага",
  funnel: "Воронка · {{month}}",
  leaderboard: {
    title: "Рейтинг: {{scope}} · {{month}}",
    team: "Команда",
    top: "Лучшие рекрутеры · {{month}}",
    full: "Полный рейтинг →",
    empty: "В этом месяце подтверждённых наймов ещё нет.",
    you: " (вы)",
    hires_one: "{{count}} найм",
    hires_few: "{{count}} найма",
    hires_many: "{{count}} наймов",
    hires_other: "{{count}} найма",
  },
  lead: { title: "Обзор команды", team: "Команда", recruiters: "Рекрутеры · {{month}}", rowHint: "Клик по строке → отчёт рекрутера", empty: "В вашей команде пока нет рекрутеров." },
  manager: { title: "Обзор филиала", branch: "Филиал", myBranches: "все мои филиалы", teams: "Команды · {{month}}" },
  owner: { title: "Обзор компании", allBranches: "все филиалы", back: "Ко всем филиалам", vs: "к {{month}}", branches: "Филиалы · {{month}}", rowHint: "Клик по строке → дашборд этого филиала", branchesEmpty: "Филиалов пока нет." },
  cols: {
    recruiter: "Рекрутер", team: "Команда", lead: "Лид", recruiters: "Рекрутеры", new: "Новые", submitted: "Отправлено", hired: "Нанято",
    retention30: "Удержание 30д", avgTime: "Ср. время", branch: "Филиал", budgetUsed: "Бюджет исп.", costPerHire: "Стоимость / найм", total: "Итого",
  },
  hiresPerWeek: "Наймы по неделям",
  hiresPerWeekSub: "подтверждённые наймы, последние 8 недель",
  hiresTip: "Наймы",
  retention: { days: "{{count}} дн.", of: " · {{retained}} из {{eligible}}" },
  lossEmpty: "За этот период потерянных водителей нет.",
  approvals: {
    title: "Ожидают подтверждения", waiting: "{{count}} ждут вашего решения",
    hires: "Наймы", expenses: "Расходы", bonuses: "Бонусы", transfers: "Переводы", review: "Открыть →", open: "Открыть подтверждения",
  },
  recent: { title: "Недавно обновлённые", empty: "Водителей пока нет. Добавьте первого водителя." },
  tasks: { title: "Задачи на сегодня", all: "Все задачи →", empty: "На сегодня ничего нет. Отлично.", markDone: "Отметить выполненной", doneFailed: "Не удалось отметить задачу выполненной" },
};
